import React from 'react'
import { useTranslation } from 'language/translator'

import { FilterPatchBody, KpiOptionObject } from 'types/GlobalKpiOption'
import { TWidgetSettings, WidgetType } from 'types/GlobalWidget'

import { useKpiOptionAttributeOptions } from 'redux/hooks/AttributeOptions'
import { useMetric } from 'redux/hooks/Metrics'

import WidgetFilterSection from '../../FilterSection'
import SettingsGroup from 'components_new/molecules/SettingsGroup'
import SettingsItem from 'components_new/molecules/SettingsItem'
import Switch from 'components_new/atoms/Switch'
import { TPatchKpiOptionBody } from 'redux/api/KpiOptions'

interface ShareKpiSectionProps {
  id: string
  kpi: KpiOptionObject
  onClose: () => void
  settings: TWidgetSettings
  updateKpiOption: (body: TPatchKpiOptionBody) => void
}

const LEGAL_TYPES = [
  WidgetType.BAR_CHART,
  WidgetType.BUBBLE_CHART,
  WidgetType.COMBO_CHART,
  WidgetType.KEY_FIGURE,
  WidgetType.LINE_CHART,
  WidgetType.MAP,
  WidgetType.LIST,
  WidgetType.PIE_CHART
]

const ShareKpiSection = (props: ShareKpiSectionProps) => {
  const { id, kpi, onClose, settings, updateKpiOption } = props
  const { t } = useTranslation()

  const metric = useMetric(kpi.kpi_template_id, kpi.variant_kpi_template_id)

  const filterAttributeOptions = useKpiOptionAttributeOptions(
    settings,
    kpi,
    'filter_attribute'
  )

  if (
    !LEGAL_TYPES.includes(settings.type.selected) ||
    !metric ||
    !metric.allow_share
  ) {
    return null
  }

  return (
    <SettingsGroup
      title={t('widgets', 'share_title')}
      helperText={t('widgets', 'share_helper_text')}
    >
      <SettingsItem
        actions={
          <Switch
            checked={kpi.is_share_kpi}
            onChange={() =>
              updateKpiOption({ is_share_kpi: !kpi.is_share_kpi })
            }
            size="small"
          />
        }
        title={t('widgets', 'show_share')}
      />
      {kpi.is_share_kpi ? (
        // The same filter section is used for both widget and kpi:
        <WidgetFilterSection
          filterAttributeOptions={filterAttributeOptions}
          filters={kpi.share_filters}
          id={id}
          onClose={onClose}
          settings={settings}
          skipHelperText={true}
          updateFilters={(filters: FilterPatchBody[]) => {
            updateKpiOption({ share_filters: filters })
          }}
        />
      ) : null}
    </SettingsGroup>
  )
}

export default ShareKpiSection
